import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4bf640ea")

_pushScopeId("data-v-4bf640ea")
const _hoisted_1 = { class: "pptist-editor" }
const _hoisted_2 = { class: "layout-content" }
const _hoisted_3 = { class: "layout-content-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Thumbnails = _resolveComponent("Thumbnails")
  const _component_Screen = _resolveComponent("Screen")
  const _component_Remark = _resolveComponent("Remark")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Thumbnails, { class: "layout-content-left" }),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Screen)
      ]),
      _createVNode(_component_Remark, {
        class: "layout-content-right center-bottom",
        height: _ctx.remarkHeight,
        "onUpdate:height": _cache[1] || (_cache[1] = ($event: any) => (_ctx.remarkHeight = $event)),
        style: { height: `100%` }
      }, null, 8, ["height"])
    ])
  ]))
})